import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTtNavLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_2",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 858.49 170.11",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#281f51;}.cls-4{fill:url(#linear-gradient-2);}" }),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient",
			x1: 68.21,
			y1: 111.14,
			x2: 68.21,
			y2: 58.8,
			gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#8f255c"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .04,
					stopColor: "#992762"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .14,
					stopColor: "#b12e71"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .27,
					stopColor: "#c3337d"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .41,
					stopColor: "#d03785"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#d7398a"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#da3a8c"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-2",
			x1: 127.88,
			y1: 111.32,
			x2: 127.88,
			y2: 58.98,
			gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#da3a8c"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4,
					stopColor: "#d7398a"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .59,
					stopColor: "#d03785"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .73,
					stopColor: "#c3337d"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .86,
					stopColor: "#b12e71"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .96,
					stopColor: "#992762"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#8f255c"
				})
			]
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1-2",
		children: [/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M285.4,61.09h-24.32v60.96h-13.47V61.09h-24.32v-12.11h62.11v12.11Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M280.23,118.87c-3.38-2.82-5.06-6.56-5.06-11.22s1.77-8.21,5.32-10.86,8.32-4.42,14.3-5.32l6.89-1.04c2.16-.35,3.69-.76,4.59-1.25,.9-.49,1.36-1.39,1.36-2.71,0-2.02-.82-3.63-2.45-4.85-1.64-1.22-3.71-1.83-6.21-1.83-2.78,0-5.08,.7-6.89,2.09-1.81,1.39-2.82,3.41-3.03,6.05l-12.84-1.04c.49-5.43,2.8-9.79,6.94-13.1,4.14-3.3,9.34-4.96,15.61-4.96,4.18,0,7.95,.77,11.33,2.3,3.37,1.53,6.05,3.83,8.04,6.89,1.98,3.06,2.98,6.75,2.98,11.07v26.62c0,2.37,.14,4.49,.42,6.37h-11.59c-.21-1.32-.31-3.3-.31-5.95v-.21c-3.34,4.8-8.8,7.2-16.39,7.2-5.29,0-9.62-1.41-13-4.23Zm10.75-7.41c1.57,1.15,3.6,1.72,6.11,1.72,3.13,0,5.67-.9,7.62-2.71,1.95-1.81,2.92-4.35,2.92-7.62v-3.97l-2.3,.42-7.73,1.25c-2.92,.49-5.15,1.17-6.68,2.04-1.53,.87-2.3,2.28-2.3,4.23s.78,3.5,2.35,4.64Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M342.81,48.98V122.06h-13.47V48.98h13.47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M361.08,119.45c-4.11-2.44-7.31-5.72-9.6-9.87-2.3-4.14-3.44-8.68-3.44-13.62s1.15-9.48,3.44-13.62c2.3-4.14,5.5-7.43,9.6-9.86,4.11-2.44,8.8-3.65,14.09-3.65,4.87,0,9.2,1.1,13,3.29,3.79,2.19,6.77,5.32,8.92,9.4,2.16,4.07,3.24,8.82,3.24,14.25,0,1.95-.07,3.45-.21,4.49h-38.21c.63,3.62,2.07,6.53,4.33,8.72,2.26,2.19,5.27,3.29,9.03,3.29,2.85,0,5.32-.7,7.41-2.09s3.58-3.24,4.49-5.53l12.42,1.25c-1.18,5.01-3.97,9.13-8.35,12.37s-9.74,4.85-16.08,4.85c-5.29,0-9.99-1.22-14.09-3.65Zm25.89-29.33c-1.53-6.96-5.6-10.44-12.21-10.44-3.41,0-6.18,.94-8.3,2.82-2.12,1.88-3.57,4.42-4.33,7.62h24.84Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M419.12,78.73c1.6-3.13,3.77-5.57,6.52-7.31,2.75-1.74,6-2.61,9.76-2.61,5.29,0,9.59,1.83,12.89,5.48,3.3,3.65,4.96,8.72,4.96,15.19v32.57h-13.47v-29.23c0-3.83-.82-6.77-2.45-8.82-1.64-2.05-4.05-3.08-7.25-3.08s-6,1.18-7.99,3.55c-1.98,2.37-2.98,5.46-2.98,9.29v28.29h-13.47v-52.2h13.47v8.87Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M485.62,122.58c-5.64,0-10.16-1.41-13.57-4.23-3.41-2.82-5.12-7.18-5.12-13.1v-23.28h-8.77v-12.11h8.77v-15.66h13.47v15.66h13.57v12.11h-13.57v20.46c0,2.57,.66,4.56,1.98,5.95,1.32,1.39,3.13,2.09,5.43,2.09,1.88,0,3.44-.35,4.7-1.04v12.21c-2.16,.63-4.45,.94-6.89,.94Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M570.17,61.09h-24.32v60.96h-13.47V61.09h-24.32v-12.11h62.11v12.11Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M571.79,119.5c-4.07-2.4-7.2-5.67-9.4-9.81-2.19-4.14-3.29-8.71-3.29-13.73s1.1-9.48,3.29-13.62c2.19-4.14,5.32-7.43,9.4-9.86,4.07-2.44,8.75-3.65,14.04-3.65s10.07,1.22,14.14,3.65,7.2,5.72,9.4,9.86c2.19,4.14,3.29,8.68,3.29,13.62s-1.1,9.59-3.29,13.73c-2.19,4.14-5.32,7.41-9.4,9.81-4.07,2.4-8.79,3.6-14.14,3.6s-9.97-1.2-14.04-3.6Zm4.33-12.84c2.36,2.89,5.6,4.33,9.71,4.33s7.45-1.44,9.81-4.33c2.37-2.89,3.55-6.45,3.55-10.7s-1.18-7.81-3.55-10.7c-2.37-2.89-5.64-4.33-9.81-4.33s-7.34,1.45-9.71,4.33c-2.37,2.89-3.55,6.46-3.55,10.7s1.18,7.81,3.55,10.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M629.51,119.5c-4.07-2.4-7.2-5.67-9.4-9.81-2.19-4.14-3.29-8.71-3.29-13.73s1.1-9.48,3.29-13.62c2.19-4.14,5.32-7.43,9.4-9.86,4.07-2.44,8.75-3.65,14.04-3.65s10.07,1.22,14.14,3.65c4.07,2.44,7.2,5.72,9.39,9.86,2.19,4.14,3.29,8.68,3.29,13.62s-1.1,9.59-3.29,13.73c-2.19,4.14-5.32,7.41-9.39,9.81-4.07,2.4-8.79,3.6-14.14,3.6s-9.97-1.2-14.04-3.6Zm4.33-12.84c2.36,2.89,5.6,4.33,9.71,4.33s7.45-1.44,9.81-4.33c2.37-2.89,3.55-6.45,3.55-10.7s-1.18-7.81-3.55-10.7c-2.37-2.89-5.64-4.33-9.81-4.33s-7.34,1.45-9.71,4.33c-2.37,2.89-3.55,6.46-3.55,10.7s1.18,7.81,3.55,10.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M689.17,48.98V122.06h-13.47V48.98h13.47Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M697.63,48.98h13.47v29.44c1.67-2.99,3.84-5.34,6.52-7.05,2.68-1.7,5.9-2.56,9.66-2.56,4.38,0,8.3,1.18,11.74,3.55,3.45,2.37,6.12,5.62,8.04,9.76,1.91,4.14,2.87,8.75,2.87,13.83s-.96,9.69-2.87,13.83c-1.92,4.14-4.59,7.39-8.04,9.76-3.44,2.37-7.36,3.55-11.74,3.55-3.76,0-6.98-.85-9.66-2.56-2.68-1.71-4.85-4.05-6.52-7.05v8.56h-13.47V48.98Zm16.81,57.67c2.23,2.89,5.32,4.33,9.29,4.33s7.08-1.44,9.34-4.33c2.26-2.89,3.39-6.45,3.39-10.7s-1.13-7.81-3.39-10.7c-2.26-2.89-5.38-4.33-9.34-4.33s-7.06,1.45-9.29,4.33c-2.23,2.89-3.34,6.46-3.34,10.7s1.11,7.81,3.34,10.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M766.89,119.5c-4.07-2.4-7.2-5.67-9.4-9.81-2.19-4.14-3.29-8.71-3.29-13.73s1.1-9.48,3.29-13.62c2.19-4.14,5.32-7.43,9.4-9.86s8.75-3.65,14.04-3.65,10.07,1.22,14.14,3.65,7.2,5.72,9.39,9.86c2.19,4.14,3.29,8.68,3.29,13.62s-1.1,9.59-3.29,13.73c-2.19,4.14-5.32,7.41-9.39,9.81-4.07,2.4-8.79,3.6-14.14,3.6s-9.97-1.2-14.04-3.6Zm4.33-12.84c2.37,2.89,5.6,4.33,9.71,4.33s7.45-1.44,9.81-4.33c2.37-2.89,3.55-6.45,3.55-10.7s-1.18-7.81-3.55-10.7c-2.37-2.89-5.64-4.33-9.81-4.33s-7.34,1.45-9.71,4.33c-2.37,2.89-3.55,6.46-3.55,10.7s1.18,7.81,3.55,10.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M823,94.6l-17.96-24.74h15.24l11.07,15.87,11.27-15.87h15.14l-18.16,25.16,18.89,27.04h-15.24l-12.21-17.75-12.11,17.75h-15.24l19.31-27.46Z"
			})
		] }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
			className: "cls-3",
			x: 12.99,
			width: 170.11,
			height: 170.11,
			rx: 24.93,
			ry: 24.93
		}), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M8.28,58.98L0,43.61H105.01c8.49,0,15.37,6.88,15.37,15.37H8.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M75.9,111.14h0c-8.49,0-15.37-6.88-15.37-15.37V58.8l15.37,13v39.34Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M191.25,111.14l8.28,15.37H91.08c-8.49,0-15.37-6.88-15.37-15.37h115.54Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-4",
				d: "M120.2,58.98h0c8.49,0,15.37,6.88,15.37,15.37v36.97l-15.37-13V58.98Z"
			})
		] })] })]
	})]
});
export { SvgTtNavLogo as ReactComponent };
